import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'

Vue.config.productionTip = false
import {ToastPlugin} from 'bootstrap-vue'
import "vue-select/dist/vue-select.css";

Vue.use(ToastPlugin);
new Vue({
  el: '#root',
  router,
  store,
  // components: { App },
  // template: '<App/>'
  /*mounted() {
    this.$router.replace('/') // added this
  },*/
  render : h => h(App)
})
